import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivationStart, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, shareReplay } from 'rxjs/operators';
import get from 'lodash/get';

type page = 'EVENT_PAGE' | 'EVENTS_PAGE' | 'HOME_PAGE';
export interface Page {
  name: page;
  e: ActivationStart
}
@Injectable({
  providedIn: 'root'
})
export class RoutingService {
  constructor(private router: Router) {}

  // add methods to get event id

  public get activatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }

  public get eventId() {
    return this.activatedRoute.snapshot.params.eventId;
  }

  public get userId() {
    return this.activatedRoute.snapshot.params.userId;
  }

  public createEventLink() {
    return `/events/create`;
  }

  viewEventLink(id: any) {
    return `/events/${id}`;
  }

  currentPage(): Observable<Page> {
    return this.router.events.pipe(
      map(e => {
        if (e instanceof ActivationStart) {
          if (e.snapshot.component === undefined) {
            return null;
          }
          let pageName: page = get(e, 'snapshot.data.name', null);

          const page = {
            name: pageName,
            e
          };

          return page;
        }
      }),
      filter(page => !!page),
      shareReplay({ bufferSize: 1, refCount: true })
    );
  }
}
